import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
          user: '', 
          user_slug: {},
          hide: false
      }
  },
  methods: {
      getUser() {
        let u = localStorage.getItem("cityneeds_user");
        if(u != null) {
            //let user = JSON.parse(u);
            //let fullname = user.user_fullname;
            this.user = u;
            this.user_slug = u.replace(" ", "_");
        }
    },
    isActive(page){
        if(page == localStorage.getItem("cn_a_current_page")){
            return "true";
        }
    },
    toggle_sidebar_mobile(){
        $('#sideToggle').toggle();
    },
    toggle_sidebar(){
        $('#sideToggle').toggle(
            // function() {
            //     $('#main-content').css('margin-left', '240px')
            // }, 
            
            function() {
                if(this.hide){
                    $('#main-content').css('margin-left', '240px')
                    this.hide = false;
                }else{
                    $('#main-content').css('margin-left', '-10px')
                    this.hide = true;
                }
            }
        );
    }
  },
  created: function() {
      this.getUser();
      localStorage.setItem("cn_a_current_page", this.$route.path);
  }
}


// WEBPACK FOOTER //
// ./src/components/Main-Header/script.js